module.exports = __webpack_public_path__ + "img/modal-img.b0848be6.svg";